import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

window._assetSource = window.assetSource || '/';
ReactDOM.render(<App />, document.getElementById('textbook-affordability-calculator'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js